var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvgFunding(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 4.65039C7.22008 4.65039 3.33008 8.54039 3.33008 13.3204C3.33008 18.1004 7.22008 22.0004 12.0001 22.0004C16.7801 22.0004 20.6701 18.1104 20.6701 13.3304C20.6701 8.55039 16.7801 4.65039 12.0001 4.65039ZM12.7501 13.0004C12.7501 13.4104 12.4101 13.7504 12.0001 13.7504C11.5901 13.7504 11.2501 13.4104 11.2501 13.0004V8.00039C11.2501 7.59039 11.5901 7.25039 12.0001 7.25039C12.4101 7.25039 12.7501 7.59039 12.7501 8.00039V13.0004Z",
    fill: "#CF9F02"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8901 3.45H9.11014C8.71014 3.45 8.39014 3.13 8.39014 2.73C8.39014 2.33 8.71014 2 9.11014 2H14.8901C15.2901 2 15.6101 2.32 15.6101 2.72C15.6101 3.12 15.2901 3.45 14.8901 3.45Z",
    fill: "#CF9F02"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvgFunding);
export default __webpack_public_path__ + "static/media/avg_funding.424d4b81f245efdca5a0c95e7d5c9778.svg";
export { ForwardRef as ReactComponent };